module.exports = new __parcel__URL__("apply_k_ja.555fa5fb.webp").toString();